import React, { useState, useEffect } from "react";

import CreateAppBtn from "../../CommonCompnents/CreateAppBtn";
import appUrl from "../../../config/MyApp/myAppsURLConfig";
import DefaultAppIcon from "../../../assets/images/defaultAppIcon.svg";
import { MYAPP_TITLE } from "../../../Containers/Client/MyApp/myAppConstents";

const MyAppsComponent = (props) => {
  const { windowWidth, setWindowWidth } = useState(window.innerWidth);
  const {
    appFormHandler,
    appsData,
    showDeleteModal,
    showAnalyticsModal,
    setIsServerErr,
    isServerErr,
  } = props;

  const [showAdditionalFeatures, setShowAdditionalFeatures] = useState({
    isShow: false,
    isId: "",
  });

  const [copyItem, setCopyItem] = useState({
    isCopied: false,
    appNm: "",
    copiedItem: "",
  });
  const [showApiModal, setApiModal] = useState("");

  const showExistingFunction = (val) => {
    setShowAdditionalFeatures({
      isShow: !showAdditionalFeatures.isShow,
      isId: val,
    });
  };

  const showApiBox = (val) => {
    if (window.innerWidth <= 760) {
      setApiModal(val);
    } else {
      setApiModal("");
    }
  };

  const clickToCopy = (e, value, item, app) => {
    console.log(e.target);
    e.preventDefault();
    setCopyItem({
      isCopied: true,
      appNm: app,
      copiedItem: item,
    });
    navigator.clipboard.writeText(value);
  };

  const hitEditBtn = (app) => {
    let isOpen = true;
    let titlel = MYAPP_TITLE.EDIT;
    let appData = app;
    appFormHandler(isOpen, titlel, appData);
  };

  const createAppBtnHandler = (isOpen, title, appData) => {
    if (appsData.actApps >= appsData.alwdActApps) {
      setIsServerErr({
        ...isServerErr,
        limitExceeded: `Only ${appsData.alwdActApps} Active app is allowed.`,
      });
    } else {
      appFormHandler(isOpen, title, appData);
    }
  };

  useEffect(() => {
    if (window.innerWidth > 760) {
      setApiModal("");
    }
  }, [windowWidth]);

  useEffect(() => {
    if (copyItem.isCopied) {
      setTimeout(() => {
        setCopyItem({
          isCopied: false,
          appNm: "",
          copiedItem: "",
        });
      }, 1000);
    }
  }, [copyItem]);

  return (
    <div>
      <div>
        <div className="myAppWrap ">
          <h3 className="myAppCount-head">My Apps</h3>
          <div className="display-space-between myAppCount">
            <div className="display-space-between">
              <div className="count">
                <h3>My Total Apps</h3>
                <p>{appsData && appsData.ntApps}</p>
              </div>
              <div className="count">
                <h3>Active Apps</h3>
                <p>{appsData && appsData.actApps}</p>
              </div>
            </div>
            <CreateAppBtn
              appFormHandler={createAppBtnHandler}
              title={MYAPP_TITLE.CREATE}
            />
          </div>
          <div className="table-responsive">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>
                    <p>Name</p>
                  </th>
                  <th>
                    <p>API Key</p>
                  </th>
                  <th>
                    <p>API Secret Key</p>
                  </th>

                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {appsData &&
                  appsData.apps.map((app, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <div
                            className="app_logo_with_name"
                            onClick={() => showApiBox(app)}
                          >
                            <img
                              className="table_app_logo"
                              src={
                                app.flLnk
                                  ? appUrl.appIcon + app.flLnk
                                  : DefaultAppIcon
                              }
                              alt="App Icon"
                            />

                            <h4>{app.appNm}</h4>
                          </div>
                        </td>
                        <td>
                          <div className="apiKey">
                            <span>{app.apiKey}</span>
                            <i
                              className="edel-icon-select pointer"
                              onClick={(e) => {
                                clickToCopy(
                                  e,
                                  app.apiKey,
                                  "Api Key",
                                  app.appNm
                                );
                              }}
                            ></i>
                          </div>
                        </td>
                        <td>
                          <span
                            className="blue-txt pointer"
                            onClick={(e) =>
                              clickToCopy(
                                e,
                                app.secKey,
                                "Secret Key",
                                app.appNm
                              )
                            }
                          >
                            Click here to copy
                          </span>
                        </td>
                        <td>
                          <p
                            className={`sq_badge ${
                              app.sts === "Active" ? " green_bdg" : " red_bdg"
                            }  green_bdg`}
                          >
                            {app.sts}
                          </p>
                        </td>
                        <td>
                          <i
                            className="edel-icon-dots-three-horizontal tooltip"
                            id="tooltip"
                            onClick={() => showExistingFunction(index)}
                          >
                            <ul
                              class="tooltiptext"
                              id={
                                showAdditionalFeatures.isShow &&
                                index === showAdditionalFeatures.isId
                                  ? "show_modal"
                                  : "hide_modal"
                              }
                            >
                              <li onClick={() => hitEditBtn(app)}>
                                <a href="#">Edit</a>
                              </li>
                              <li onClick={() => showDeleteModal(true, app)}>
                                <a href="#">Delete</a>
                              </li>
                              <li onClick={() => showAnalyticsModal(true, app)}>
                                <a href="#">View Analytics</a>
                              </li>
                            </ul>
                          </i>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>

        <div className="creatBt-mobile">
          <CreateAppBtn
            appFormHandler={createAppBtnHandler}
            title={MYAPP_TITLE.CREATE}
          />
        </div>
      </div>

      {copyItem.isCopied && (
        <div className="copied_container">
          <div className="copied_item">
            <p>{`"${copyItem.appNm}" App ${copyItem.copiedItem} Copied`}</p>
          </div>
        </div>
      )}

      {showApiModal !== "" && (
        <div class="modal_api">
          <div className="apiModelContent">
            <div className="closeIcon">
              <i
                className="edel-icon-close"
                onClick={() => {
                  showApiBox("");
                }}
              ></i>
            </div>
            <div className="table-responsive">
              <table className="custom-table">
                <tbody>
                  <tr>
                    <td>
                      <div className="app_logo_with_name">
                        <img
                          className="table_app_logo"
                          src={
                            showApiModal.flLnk
                              ? appUrl.appIcon + showApiModal.flLnk
                              : DefaultAppIcon
                          }
                          alt="app icon"
                        />
                        <span>{showApiModal.appNm}</span>
                      </div>
                    </td>
                    <td>
                      <p
                        className={`sq_badge ${
                          showApiModal.sts === "Active"
                            ? " green_bdg"
                            : " red_bdg"
                        }  green_bdg`}
                      >
                        {showApiModal.sts}
                      </p>
                    </td>
                    <td>
                      <i
                        className="edel-icon-dots-three-horizontal tooltip"
                        onClick={() => showExistingFunction()}
                      >
                        <ul
                          class="tooltiptext"
                          id={
                            showAdditionalFeatures.isShow
                              ? // index === showAdditionalFeatures.isId
                                "show_modal"
                              : "hide_modal"
                          }
                        >
                          <li onClick={() => hitEditBtn(showApiModal)}>
                            <a href="#">Edit</a>
                          </li>
                          <li
                            onClick={() => showDeleteModal(true, showApiModal)}
                          >
                            <a href="#">Delete</a>
                          </li>
                          <li
                            onClick={() =>
                              showAnalyticsModal(true, showApiModal)
                            }
                          >
                            <a href="#">View Analytics</a>
                          </li>
                        </ul>
                      </i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="copy_section">
              <div className="copy_section_flex">
                <div>
                  <span>Api Key</span>
                  <p>{showApiModal.apiKey}</p>
                </div>
                <button
                  onClick={(e) => {
                    clickToCopy(
                      e,
                      showApiModal.apiKey,
                      "Api Key",
                      showApiModal.appNm
                    );
                  }}
                >
                  Copy
                </button>
              </div>
              <div className="copy_section_flex">
                <div>
                  <span>App Secret Key</span>
                  <p>
                    &#x25cf; &#x25cf; &#x25cf; &#x25cf; &#x25cf; &#x25cf;
                    &#x25cf; &#x25cf;
                  </p>
                </div>
                <button
                  onClick={(e) => {
                    clickToCopy(
                      e,
                      showApiModal.secKey,
                      "Secret Key",
                      showApiModal.appNm
                    );
                  }}
                >
                  Copy
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyAppsComponent;
